__turbopack_context__.v({
  "fadeInUp": "MobileMenu-module__AP24jW__fadeInUp",
  "linkIcon": "MobileMenu-module__AP24jW__linkIcon",
  "linkNumber": "MobileMenu-module__AP24jW__linkNumber",
  "linkText": "MobileMenu-module__AP24jW__linkText",
  "mobileClose": "MobileMenu-module__AP24jW__mobileClose",
  "mobileContact": "MobileMenu-module__AP24jW__mobileContact",
  "mobileContent": "MobileMenu-module__AP24jW__mobileContent",
  "mobileDecor": "MobileMenu-module__AP24jW__mobileDecor",
  "mobileDecor1": "MobileMenu-module__AP24jW__mobileDecor1",
  "mobileDecor2": "MobileMenu-module__AP24jW__mobileDecor2",
  "mobileLink": "MobileMenu-module__AP24jW__mobileLink",
  "mobileLinkCta": "MobileMenu-module__AP24jW__mobileLinkCta",
  "mobileLogo": "MobileMenu-module__AP24jW__mobileLogo",
  "mobileMenu": "MobileMenu-module__AP24jW__mobileMenu",
  "mobileMenuActive": "MobileMenu-module__AP24jW__mobileMenuActive",
  "mobileNav": "MobileMenu-module__AP24jW__mobileNav",
  "slideInLeft": "MobileMenu-module__AP24jW__slideInLeft",
});
